<template>
  <GmapMarker
    v-if="show"
    :position="location"
    :clickable="false"
    :draggable="false"
    :zIndex="1"
    :icon="icon"
  >
  </GmapMarker>
</template>

<script>
import { mapGetters } from 'vuex'
import { gmapApi } from 'vue2-google-maps'
import iconPath from '@/assets/images/icon-location.svg'

export default {
  computed: {
    ...mapGetters({
      location: 'geolocation/getLocation',
      status: 'reservation/getStatus'
    }),
    google: gmapApi,
    show: function () {
      return this.status == 'RESERVED'
    },
    icon: function () {
      return {
        url: iconPath,
        scaledSize: new this.google.maps.Size(36, 36)
      }
    }
  }
}
</script>
